import Vue from 'vue'
import Router from 'vue-router'
import store from '../vuex/store'
import i18n from '../config/i18n'

import Welcome from '@/components/spa/welcome/Layout.vue'
import Guide from '@/components/spa/welcome/Guide.vue'
import Plans from '@/components/spa/welcome/Plans.vue'
// import Support from '@/components/spa/welcome/Support.vue'
import Privacy from '@/components/spa/welcome/Privacy.vue'
import Policy from '@/components/spa/welcome/Policy.vue'
import CommercialTerms from '@/components/spa/welcome/CommercialTerms.vue'
import WhatsNew from '@/components/spa/welcome/WhatsNew.vue'
import Notice from '@/components/spa/welcome/Notice.vue'

import EmailConfirm from '@/components/spa/common/EmailConfirm.vue'
import PasswordReset from '@/components/spa/common/PasswordReset.vue'

// import Gallery from '@/components/spa/gallery/Layout.vue'
import Masterpiece from '@/components/spa/gallery/Piece.vue'

import Lab from '@/components/spa/lab/Layout.vue'
import Project from '@/components/spa/project/Layout.vue'
import WatchingProject from '@/components/spa/project-watching/Layout.vue'

import Account from '@/components/spa/common/Account.vue'
import Issues from '@/components/spa/common/Issues.vue'

import Login from '@/components/spa/common/Login.vue'
import Signup from '@/components/spa/common/signup.vue'
import CheckPayment from '@/components/spa/common/CheckPayment.vue'
import UpdatePayment from '@/components/spa/common/UpdatePayment.vue'

import NotFound from '@/components/spa/common/NotFound.vue'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const ROUTES = [
    // Public paths
    { path: '*', name: 'notfound', component: NotFound },
    {
        path: '/',
        name: 'welcome',
        component: Welcome,
    },
    {
        path: '/guide',
        name: 'guide',
        component: Guide,
    },
    {
        path: '/plans',
        name: 'plans',
        component: Plans,
    },
    // {
    //     path: '/support',
    //     name: 'support',
    //     component: Support,
    // },
    {
        path: '/policy/',
        name: 'policy',
        component: Policy,
    },
    {
        path: '/policy/:code',
        name: 'policyform',
        component: Policy,
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Privacy,
    },
    {
        path: '/commercial-terms/',
        name: 'commercial-terms',
        component: CommercialTerms,
    },
    {
        path: '/commercial-terms/:code',
        name: 'commercial-termsform',
        component: CommercialTerms,
    },
    {
        path: '/whats-new',
        name: 'whats-new',
        component: WhatsNew,
    },
    {
        path: '/notice',
        name: 'notice',
        component: Notice,
    },
    // Private paths
    {
        path: '/lab',
        name: 'lab',
        component: Lab,
        meta: { private: true },
    },
    {
        path: '/watching-projects',
        name: 'watching-projects',
        component: Lab,
        meta: { private: true },
    },
    {
        path: '/lab/project/:id',
        name: 'project',
        component: Project,
        meta: { private: true },
        props: (route) => ({
            doc: route.query.doc,
            mode: route.query.mode,
            vid: route.query.vid,
            comments: route.query.comments,
        })
    },
    {
        path: '/lab/watching-project/:id',
        name: 'watching-project',
        component: WatchingProject,
        meta: { private: true },
        props: (route) => ({
            doc: route.query.doc,
            vid: route.query.vid,
            comments: route.query.comments,
        })
    },
    {
        path: '/document-clip',
        name: 'document-clip',
        component: Lab,
        meta: { private: true },
        props: (route) => ({
            doc: route.query.doc,
        })
    },
    {
        path: '/reviews',
        name: 'reviews',
        component: Lab,
        meta: { private: true },
        props: (route) => ({
            doc: route.query.doc,
        })
    },
    {
        path: '/issues',
        name: 'issues',
        component: Issues,
        meta: { private: true },
    },
    {
        path: '/issues/:id',
        name: 'issue',
        component: Issues,
        meta: { private: true },
    },
    // {
    //     path: '/gallery',
    //     name: 'gallery',
    //     component: Gallery,
    //     meta: { private: true },
    // },
    // {
    //     path: '/gallery/mp/:id',
    //     name: 'masterpiece',
    //     component: Masterpiece,
    //     meta: { private: true },
    // },
    {
        path: '/gallery/bruno-latour',
        name: 'masterpiece',
        component: Masterpiece,
        meta: { private: true },
    },
    {
        path: '/account',
        name: 'account',
        component: Account,
        meta: { private: true }
    },
    // Special paths
    {
        path: '/login',
        name: 'login',
        component: Login,
        props: (route) => ({
            step: route.query.step,
        })
    },
    {
        path: '/email_confirm',
        name: 'email_confirm',
        component: EmailConfirm,
        props: (route) => ({
            token: route.query.token
        })
    },
    {
        path: '/password_reset',
        name: 'password_reset',
        component: PasswordReset,
        props: (route) => ({
            token: route.query.token
        })
    },
    {
        path: '/signup/',
        name: 'signup',
        component: Signup,
    },
    {
        path: '/signup/:code',
        name: 'signupform',
        component: Signup,
    },
    {
        path: '/check-payment',
        name: 'check-payment',
        component: CheckPayment,
    },
    {
        path: '/update-payment',
        name: 'update-payment',
        component: UpdatePayment,
    },
]

const router = new Router({
    routes: ROUTES,
    mode: 'history',
    // scrollBehavior(to) {
    //     if (to.hash) {
    //         return {
    //             selector: to.hash,
    //             offset: { x: 100, y: 100 },
    //         }
    //     }
    // }
})

export default router

router.beforeResolve((to, from, next) => {
    let token = store.getters['auth/access_token']
    let status = store.getters['auth/token_status']
    let role = store.getters['auth/token_role']
    let memberships = store.getters['auth/token_memberships']
    let membership = !!memberships.length ? memberships.slice(-1).pop() : null
    let is_fresh = store.getters['auth/token_fresh']
    let language = store.getters['auth/language'] || 'ko'
        // let language = store.getters['auth/language'] || navigator.language.split('-')[0]
    i18n.locale = language
    if (to != from) {
        if (to.matched.some(r => r.meta.private)) {
            if (!token) {
                return next({
                    name: 'login',
                    params: { wantedRoute: to.fullPath }
                })
            } else {
                if (to.name == 'account') {
                    if (!is_fresh) {
                        return next({
                            name: 'login',
                            params: { wantedRoute: to.fullPath }
                        })
                    }
                } else {
                    if (role != 1) {
                        if (!memberships.length) {
                            store.commit('auth/setExpired', true)
                        } else if ((new Date(membership.end_date)).setHours(24, 0, 0, 0) < new Date().getTime()) {
                            store.commit('auth/setExpired', true)
                        } else {
                            store.commit('auth/setExpired', false)
                        }
                    }
                }
            }
        } else if (to.name == 'welcome') {
            if (!!token) {
                return next({ name: 'lab' })
            }
        } else if (to.name == 'login') {
            if (!!token) {
                if (to.params.wantedRoute == '/account') {
                    if (is_fresh) { return next({ name: 'account' }) }
                } else {
                    return next({ name: 'lab' })
                }
            }
        } else if (to.name == 'email_confirm') {
            if (!token) {
                return next({
                    name: 'login',
                    params: { wantedRoute: to.fullPath }
                })
            } else if (status) {
                return next({ name: 'lab' })
            }
        }
    }
    next()

})


// WEBPACK FOOTER //
// ./src/config/router.js